import { SystemEvent } from '../enum';
import { ExternalBotEvent } from '../enum/ExternalBotEvent';
import { SystemOptionEvent, ActionOptionEvent, NoneOfTheAboveEvent, ArticleExpandedEvent, RollbackEvent, BaseEvent, AltResolutionEvent, ArticleInteractionExternEvent, CancelSupportRequestExternEvent, BaseExternalEvent, ActionSelectedEvent, ArticleListNavigationEvent, PreSupportSelectionEvent, AlternativeActionSelectedEvent } from '../types';

export function isOptionEvent (event: any): event is SystemOptionEvent {
  return event?.type === SystemEvent.LIST_OPTION_SELECTED;
}

export function isResolutionEvent (event: any): event is ActionOptionEvent {
  return event?.type === SystemEvent.USER_RESOLUTION_SELECTED;
}

export function isNoneOfTheAboveEvent (event: any): event is NoneOfTheAboveEvent {
  return event?.type === SystemEvent.NONE_OF_THE_ABOVE_SELECTED;
}

export function isArticleExpandedEvent (event: any): event is ArticleExpandedEvent {
  return event?.type === SystemEvent.ARTICLE_PREVIEW_EXPANDED;
}

export function isRollbackEvent (event: any): event is RollbackEvent {
  return event?.type === SystemEvent.USER_ROLLBACK;
}

export function isisAltResolutionEvent (event: any): event is AltResolutionEvent {
  return event?.type === SystemEvent.ALTERNATIVE_ACTION;
}

export function isActionSelectedEvent (event: any): event is ActionSelectedEvent {
  return event?.type === SystemEvent.ACTION_SELECTED;
}

export function isArticleListNavigationEvent (event: any): event is ArticleListNavigationEvent {
  return event?.type === SystemEvent.ARTICLE_LIST_NAVIGATION;
}

export function isArticleInteractionEvent (event: any): event is ArticleInteractionExternEvent {
  return event?.type === ExternalBotEvent.ARTICLE_PAGE_INTERACTION;
}

export function isCancelSupportRequestEvent (event: any): event is CancelSupportRequestExternEvent {
  return event?.type === ExternalBotEvent.CANCEL_SUPPORT_REQUEST;
}

export function isExternalEvent (event: any): event is BaseExternalEvent {
  return (event?.type as string || '').startsWith('external.sys');
}

export function isPreSupportPromptSelectionEvent (event: any): event is PreSupportSelectionEvent {
  return event?.type === SystemEvent.PRE_SUPPORT_SELECTION;
}

export function isAlternativeActionEvent (event: any): event is AlternativeActionSelectedEvent {
  return event?.type === SystemEvent.ALTERNATIVE_ACTION;
}
